import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
    name: 'assetVersion',
    standalone: true
})
export class AssetVersionPipe implements PipeTransform {

    transform(value?: string): string {
        if (!value) {
            return '';
        }
        const separator = value.includes('?') ? '&' : '?';
        return `${value}${separator}v=${environment.appVersion}`;
    }

}
